"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Condition = exports.Qualities = exports.Brand = exports.PatternType = void 0;
var PatternType;
(function (PatternType) {
    PatternType["Womenswear"] = "Womenswear";
    PatternType["Childrenswear"] = "Childrenswear";
    PatternType["Accessories"] = "Accessories";
    PatternType["Menswear"] = "Menswear";
    PatternType["Junior"] = "Junior";
    PatternType["Craft"] = "Craft";
    PatternType["Unisex"] = "Unisex";
})(PatternType = exports.PatternType || (exports.PatternType = {}));
var Brand;
(function (Brand) {
    Brand["Burda"] = "Burda";
    Brand["Butterick"] = "Butterick";
    Brand["Kwik Sew"] = "Kwik Sew";
    Brand["McCall's"] = "McCall's";
    Brand["See & Sew"] = "See & Sew";
    Brand["Simplicity"] = "Simplicity";
    Brand["Vogue"] = "Vogue";
    Brand["New Look"] = "New Look";
})(Brand = exports.Brand || (exports.Brand = {}));
var Qualities;
(function (Qualities) {
    Qualities["Vintage"] = "Vintage";
    Qualities["Costume"] = "Costume";
})(Qualities = exports.Qualities || (exports.Qualities = {}));
var Condition;
(function (Condition) {
    Condition["Open"] = "Open";
    Condition["Sealed"] = "Sealed";
})(Condition = exports.Condition || (exports.Condition = {}));
//# sourceMappingURL=sewingPatternAttributes.js.map